import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Standard Tailwind className composer — clsx for conditionals, tailwind-merge to resolve conflicting utilities (e.g. two `p-*` values). */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
